// Mock data for TruCrunch clone

export const flavors = [
  {
    id: 'spicy',
    title: 'SPICY',
    subtitle: 'Peri Peri · Chilli Tomato',
    color: '#E63946',
    bg: '#FFE4E1',
    image: 'https://images.unsplash.com/photo-1613919113640-25732ec5e61f?crop=entropy&cs=srgb&fm=jpg&q=85&w=600'
  },
  {
    id: 'cheesy',
    title: 'CHEESY',
    subtitle: 'Cheese & Herbs',
    color: '#F4A300',
    bg: '#FFF1CC',
    image: 'https://images.unsplash.com/photo-1669056544004-96abfb7a5008?crop=entropy&cs=srgb&fm=jpg&q=85&w=600'
  },
  {
    id: 'sweet',
    title: 'SWEET',
    subtitle: 'Mocha Cookie · Choco Bar',
    color: '#8B4513',
    bg: '#F5E4D0',
    image: 'https://images.unsplash.com/photo-1598839950984-034f6dc7b495?crop=entropy&cs=srgb&fm=jpg&q=85&w=600'
  },
  {
    id: 'protein',
    title: 'PROTEIN',
    subtitle: 'Propufz · Millet Rings',
    color: '#2A9D8F',
    bg: '#D8F0EC',
    image: 'https://images.unsplash.com/photo-1599490659213-e2b9527bd087?crop=entropy&cs=srgb&fm=jpg&q=85&w=600'
  }
];

export const ingredients = [
  {
    id: 'jowar', name: 'JOWAR',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/mf2jkbrd_image.png',
    color: '#E9C46A',
    tagline: 'The ancient grain that beats bloat.',
    fact: 'Jowar (sorghum) has been grown in India for over 5,000 years and stays gluten-free by nature.',
    benefits: [
      'Naturally gluten-free & easy on the gut',
      'Loaded with fibre — keeps you full longer',
      'Rich in iron, magnesium & B-vitamins',
      'Low glycemic — helps steady blood sugar'
    ]
  },
  {
    id: 'ragi', name: 'RAGI',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/n8tn7udq_image.png',
    color: '#B08968',
    tagline: 'Tiny grain. Giant calcium.',
    fact: 'Ragi (finger millet) has up to 10x more calcium than brown rice — one of the highest of any grain.',
    benefits: [
      'Superstar for bone strength',
      'Packed with iron — helps beat fatigue',
      'Rich in amino acids for repair & recovery',
      'Slow-release energy for real focus'
    ]
  },
  {
    id: 'quinoa', name: 'QUINOA',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/79nt8g83_image.png',
    color: '#DDB892',
    tagline: 'A complete protein in every bite.',
    fact: 'Quinoa contains all 9 essential amino acids — a rare status called a “complete protein”.',
    benefits: [
      'Complete plant protein — great for muscles',
      'High fibre + low GI = steady energy',
      'Loaded with magnesium, iron & folate',
      'Gluten-free and super gut-friendly'
    ]
  },
  {
    id: 'moong', name: 'MOONG',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/1lnhkuf3_image.png',
    color: '#A7C957',
    tagline: 'The easiest protein your body loves.',
    fact: 'Moong dal is one of the most easily digestible plant proteins — a staple in Ayurveda for recovery meals.',
    benefits: [
      'High protein, low fat — clean fuel',
      'Rich in folate & B-vitamins',
      'Aids digestion & feels light on the gut',
      'Great for muscle repair & recovery'
    ]
  },
  {
    id: 'soy', name: 'SOY',
    image: 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts/uc99v426_image.png',
    color: '#E76F51',
    tagline: 'Plant protein that actually packs.',
    fact: 'Soy is one of the very few plants that gives you all 9 essential amino acids like animal protein.',
    benefits: [
      'Complete plant protein powerhouse',
      'Supports heart health & good cholesterol',
      'Loaded with isoflavones & antioxidants',
      'Great source of calcium & iron'
    ]
  }
];

// Upcoming products (packaging designs only — not launched yet)
const ASSET = 'https://customer-assets-cm19k8pv.emergentagent.net/job_trucrunch-games/artifacts';
export const upcomingProducts = [
  {
    id: 'jowar-chips-peri-peri',
    line: 'Jowar Chips',
    flavor: 'Peri Peri',
    price: 20,
    weight: '30g',
    image: null,
    bg: '#FFE9E3',
    color: '#E63946',
    tags: ['High in Plant Protein', 'Rich in Fiber', 'Real Jowar']
  },
  {
    id: 'jowar-chips-chilli-tomato',
    line: 'Jowar Chips',
    flavor: 'Chilli Tomato',
    price: 20,
    weight: '30g',
    image: `${ASSET}/yv944m6l_1c9ca2bb-92f0-461d-9b75-b5f1f9d6e729.jpeg`,
    bg: '#FFE9E3',
    color: '#E63946',
    tags: ['High in Plant Protein', 'Rich in Fiber', 'Real Jowar']
  },
  {
    id: 'quinoa-chips-peri-peri',
    line: 'Quinoa Chips',
    flavor: 'Peri Peri',
    price: 20,
    weight: '30g',
    image: `${ASSET}/4k5op8ul_93dfb1fc-ec52-4a10-bee1-b907b87e43f1.jpeg`,
    bg: '#FFF1DC',
    color: '#E38B0A',
    tags: ['High in Plant Protein', 'High in Fiber', 'Real Quinoa Goodness']
  },
  {
    id: 'quinoa-chips-chilli-tomato',
    line: 'Quinoa Chips',
    flavor: 'Chilli Tomato',
    price: 20,
    weight: '30g',
    image: null,
    bg: '#FFF1DC',
    color: '#E38B0A',
    tags: ['High in Plant Protein', 'High in Fiber', 'Real Quinoa Goodness']
  },
  {
    id: 'pufz-tangy-tomato',
    line: 'Protein Pufz Millet Rings',
    flavor: 'Tangy Tomato',
    price: 20,
    weight: '30g',
    image: `${ASSET}/3qz1a72h_26628c02-670f-4c94-960a-f739479925fb.jpeg`,
    bg: '#FFE9E3',
    color: '#C1440E',
    tags: ['71% Millet & Pulse Mix', '5g Protein per Pack', 'Real Ingredients']
  },
  {
    id: 'pufz-herb-cheese',
    line: 'Protein Pufz Millet Rings',
    flavor: 'Herb & Cheese',
    price: 20,
    weight: '30g',
    image: `${ASSET}/iyf5gqd8_0749b43d-173d-485e-b73f-c478bca9c5e6.jpeg`,
    bg: '#FFF1DC',
    color: '#B26A00',
    tags: ['71% Millet & Pulse Mix', '5g Protein per Pack', 'Real Ingredients']
  }
];

// Junk / boring items for the game
export const junkItems = [
  { id: 'sugar', name: 'SUGAR', emoji: 'candy' },
  { id: 'oil', name: 'PALM OIL', emoji: 'droplet' },
  { id: 'msg', name: 'MSG', emoji: 'flask-conical' },
  { id: 'preserv', name: 'PRESERVATIVES', emoji: 'ban' },
  { id: 'artif', name: 'ARTIFICIAL', emoji: 'x-circle' }
];

export const marqueeWords = [
  'BIG CRUNCH', 'REAL INGREDIENTS', 'ZERO BORING BITES', 'INGREDIENT FIRST', 'CRAVING ALWAYS', 'MADE IN INDIA'
];

export const leaderboard = [];

export const faqs = [
  {
    q: 'What makes TruCrunch different?',
    a: 'We put real Indian grains — ragi, jowar, quinoa, moong — as the FIRST ingredient. No filler flour, no mystery additives, and never any unnecessary preservatives. Just big, honest crunch.'
  },
  {
    q: 'How much do TruCrunch packs cost?',
    a: 'Our snack packs are priced between ₹80 and ₹149 depending on the flavor and size. Multi-packs and combo boxes offer better value.'
  },
  {
    q: 'Which products are available now?',
    a: 'We are launching very soon! Right now the kitchen is finalising the last batch of Spicy, Cheesy, Sweet and Protein packs. Play the game to be first in line.'
  },
  {
    q: 'Where can I buy TruCrunch?',
    a: 'At launch, TruCrunch will be available on our own store, Amazon, Zepto, Blinkit and select premium retailers across India.'
  },
  {
    q: 'What is your shipping policy?',
    a: 'Free shipping across India on orders above ₹499. Standard delivery in 3–5 business days. Metro cities get express next-day delivery.'
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Nikhil A.',
    city: 'Mumbai',
    rating: 5,
    text: 'Finally a snack that doesn\u2019t pretend to be healthy. Real crunch, real millet, and the peri peri hits!'
  },
  {
    id: 2,
    name: 'Pooja D.',
    city: 'Bengaluru',
    rating: 5,
    text: 'I demolished a pack in one sitting. The cheesy one is dangerous — in a good way.'
  },
  {
    id: 3,
    name: 'Rahul V.',
    city: 'Delhi',
    rating: 4,
    text: 'Love that ragi is the first ingredient. Kids ate it without knowing it\u2019s healthy. Big win.'
  }
];

export const contestEndDate = new Date();
contestEndDate.setDate(contestEndDate.getDate() + 25);
contestEndDate.setHours(contestEndDate.getHours() + 4);
